module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', [_vm._v("Table of Contents")]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright Page")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/c002"
    }
  }, [_vm._v("Fae-mous: A Why Choose YA/New Adult Paranormal Urban Romance (Fallen Fae B.I. Series, #2)")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/c003"
    }
  }, [_vm._v("Note")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/c004"
    }
  }, [_vm._v("Chapter 1 | Harley")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/c005"
    }
  }, [_vm._v("Chapter 2")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9 | Oakley")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10 | Oakley")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11 | Harley")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12 | Kingsley")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13 | Kingsley")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14 | Harley")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15 | Harley")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16 | Harley")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c020",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17 | Harley")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c021",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue | Harley")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c022",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thank You for reading")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c023",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Get a Free Gift from Romance on the Go!")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d3bbc574","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/toc.vue
// module id = 60
// module chunks = 0